import { ScheduleDataIntervalPeriod } from './scheduler.model';

// shared-email-sftp-exporter
export type ScheduleDataSftpExporter = {
    intervalPeriod?: string;
    intervalUnit?: 'minute' | 'hour' | 'week' | 'month';
    daysOfTheWeek: string[];
    startTime: string;
    endTime: string;
} & ScheduleDataIntervalPeriod;

export class AppInstanceSchedule {
    appinstanceId?: number;
    eloquainstallId?: number;
    jobGroup?: string;
    unknownJobGroupName?: string;
    jobClassName?: string;
    scheduleTemplate?: ScheduleTemplate;
    executionData?: {};
    triggerData?: {};
    additionalNamingParameters?: string[];
}

export class ScheduleTemplate {
    scheduleType?: string;
    intervalPeriod?: number;
    intervalUnit?: string;
    daysOfTheWeek?: string[];
    startTime?: string;
    endTime?: string;
    firstRunDate?: Date;
    nextRunDate?: Date;
    lastRunDate?: Date;
}
